
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2rhyz_1ru9f_93",
  "input": "awsui_input_2rhyz_1ru9f_97",
  "input-readonly": "awsui_input-readonly_2rhyz_1ru9f_120",
  "input-invalid": "awsui_input-invalid_2rhyz_1ru9f_181",
  "input-has-icon-left": "awsui_input-has-icon-left_2rhyz_1ru9f_192",
  "input-type-search": "awsui_input-type-search_2rhyz_1ru9f_197",
  "input-has-icon-right": "awsui_input-has-icon-right_2rhyz_1ru9f_213",
  "input-has-no-border-radius": "awsui_input-has-no-border-radius_2rhyz_1ru9f_216",
  "input-container": "awsui_input-container_2rhyz_1ru9f_220",
  "input-icon-left": "awsui_input-icon-left_2rhyz_1ru9f_225",
  "input-icon-right": "awsui_input-icon-right_2rhyz_1ru9f_232",
  "input-button-right": "awsui_input-button-right_2rhyz_1ru9f_238"
};
  